{
  "name": "fincomp-uiapp",
  "version": "1.1.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "type-check": "tsc --noEmit",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,json}\"",
    "format:fix": "prettier --write \"src/**/*.{ts,html,scss,json}\"",
    "lint": "ng lint",
    "test": "ng test --watch=false --browsers=ChromeHeadless --code-coverage",
    "watch": "ng build --watch --configuration development",
    "build": "npm run format:fix && npm run lint && npm run type-check && npm run test && ng build",
    
    "serve:staging": "ng serve --configuration=staging",
    "serve:ssr:fincomp-uiapp": "node dist/fincomp-uiapp/server/server.mjs",
    "serve:ssr:dev": "ng build --configuration=development && node dist/fincomp-uiapp/server/server.mjs",
    "serve:ssr:staging": "ng build --configuration=staging && node dist/fincomp-uiapp/server/server.mjs",

    "copy:dist": "xcopy /E /I /Y dist\\fincomp-uiapp\\browser ..\\dist\\public\\browser && xcopy /E /I /Y dist\\fincomp-uiapp\\browser ..\\public\\browser",
    "build:all": "npm run build && npm run copy:dist",

    "build:staging": "ng build --configuration=staging",
    "build:all:staging": "npm run build:staging && npm run copy:dist",
    
    "build:prod": "ng build --configuration=production",
    "build:all:prod": "npm run build:prod && npm run copy:dist",

    "serve:prod": "ng serve --configuration=production",
    "serve:ssr:prod": "ng build --configuration=production && node dist/fincomp-uiapp/server/server.mjs",
    
    "copy:distlinux": "mkdir -p ../dist/public/browser ../public/browser && rsync -a --delete dist/fincomp-uiapp/browser/ ../dist/public/browser/ && rsync -a --delete dist/fincomp-uiapp/browser/ ../public/browser/",
    "build:linux": "npm run build && npm run copy:distlinux",
    "build:linux:prod": "npm run build:prod && npm run copy:distlinux"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "~18.2.3",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/platform-server": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@angular/ssr": "^18.2.3",
    "@auth0/auth0-angular": "^2.2.3",
    "@azure/msal-angular": "^4.0.12",
    "@azure/msal-browser": "^4.13.1",
    "@microsoft/signalr": "^9.0.6",
    "@okta/okta-angular": "^6.5.1",
    "@okta/okta-auth-js": "^7.12.1",
    "chart.js": "^4.4.4",
    "compression": "^1.8.1",
    "express": "^4.18.2",
    "file-saver": "^2.0.5",
    "html2pdf.js": "^0.10.2",
    "jspdf": "^3.0.1",
    "jspdf-autotable": "^5.0.2",
    "jwt-decode": "^4.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.3",
    "@angular-eslint/builder": "18.4.1",
    "@angular-eslint/eslint-plugin": "18.4.1",
    "@angular-eslint/eslint-plugin-template": "18.4.1",
    "@angular-eslint/schematics": "18.4.1",
    "@angular-eslint/template-parser": "18.4.1",
    "@angular/cli": "^18.2.19",
    "@angular/compiler-cli": "^18.2.0",
    "@types/express": "^4.17.17",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "@types/jwt-decode": "^3.1.0",
    "@types/node": "^18.18.0",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "eslint": "8.57.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.6.2",
    "typescript": "~5.5.2"
  }
}
